const overPressureColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 360
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 160
  },
  {
    zh: '平均频率(Hz)',
    en: 'Average Frequency(Hz)',
    dataIndex: 'avgOutRate',
    key: 'avgOutRate',
    tooltip: true
  },
  {
    zh: '上限频率(Hz)',
    en: 'Upper Limit Frequency(Hz)',
    dataIndex: 'upperRateLimit',
    key: 'upperRateLimit',
    tooltip: true
  },
  {
    zh: '下限频率(Hz)',
    en: 'Lower Limit Frequency(Hz)',
    dataIndex: 'lowerRateLimit',
    key: 'lowerRateLimit',
    tooltip: true
  },
  {
    zh: '设定压力(Mpa)',
    en: 'Rated Pressure(Mpa)',
    dataIndex: 'settingPressure',
    key: 'settingPressure',
    tooltip: true
  },
  {
    zh: '平均压力(Mpa)',
    en: 'Average Pressure(Mpa)',
    dataIndex: 'avgPressure',
    key: 'avgPressure',
    tooltip: true
  },
  {
    zh: '平均温度(℃)',
    en: 'Average Temperature(℃)',
    dataIndex: 'avgTemperature',
    key: 'avgTemperature',
    tooltip: true
  }
]

export default overPressureColumns